import { useUserState } from '@juvare/contact-management/ui/hooks';
import { useNotifyClient } from '@juvare/platform-sdk-react/ui/hooks';
import React from 'react';
import { AlertServiceClient } from '../../../clients/AlertServiceClient';
export function useAlertServiceClient() {
    const { id } = useUserState();
    const notifyClient = useNotifyClient();
    return React.useMemo(() => {
        return new AlertServiceClient({
            onTokenRequest: () => notifyClient.getAlertToken().then((response) => response.token),
        });
        // depending on user id, when it changes (impersonation feature?) we want a new token
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [notifyClient, id]);
}
